module.exports = __webpack_public_path__ + "media/app/assets/races/orc_male-d364fa9cac5b10a7f1b2ad4dca70074d.png";